import { Typography, Stack } from "@mui/material";
import { useEffect, useMemo, useState } from "react";
import { Controller } from "react-hook-form";
import { useParams } from "react-router-dom";

import { PackageCard } from "./PackageCard";
import { useGetPackages } from "./utility";
import { useUtilityContent } from "./UtilityContent";
import { formatMoney } from "../../helper/numberFormat";
import { FormInput, FormSelect } from "../../atoms";
const initialAmountState = { amount: 0, disable: false };

export const BillFormSection = () => {
  const { billerId } = useParams();
  const { mutate: getPackages, data: biller } = useGetPackages(billerId);
  const [amount, setAmount] = useState(initialAmountState);
  const { setBill } = useUtilityContent();
  const {
    form: {
      watch,
      setValue,
      register,
      control,
      formState: { errors },
    },
  } = useUtilityContent();
  useEffect(() => {
    getPackages(billerId, {
      onSuccess: (result) => {
        setBill({ categoryName: result.categoryName, name: result.name, logoUrl: result.logoUrl });
      },
    });
  }, []);
  const model = watch();
  useEffect(() => {
    var pkgs = biller?.packages.filter((x) => x.packageId === model.packageId);
    if (pkgs && pkgs?.length > 0) {
      const amount = pkgs[0].amount;
      setValue("amount", amount as any);
      if (amount > 0) {
        setAmount({ amount: amount, disable: true });
        return;
      }
    }
    setAmount(initialAmountState);
  }, [model.packageId]);

  var transactionFee = useMemo(() => {
    var surgeCharge = biller?.surcharge || 0;
    var feeCharge = "5% of Amount";
    if (surgeCharge > 0) {
      return `${formatMoney(surgeCharge)} + ${feeCharge}`;
    }
    return feeCharge;
  }, [biller]);

  return (
    <div>
      <PackageCard />
      <div style={{ marginTop: "40px" }}>
        <Typography sx={{ fontSize: "20px", fontWeight: 700, lineHeight: "24px" }}>{biller?.categoryName}</Typography>
        <Stack spacing={3} sx={{ marginTop: "40px" }}>
          <Stack spacing={2} direction="row">
            <FormInput required label={biller?.customerField || "Customer No"} {...register("customerId")} helperText={errors.customerId?.message} />
            <Controller
              control={control}
              name="packageId"
              render={({ field }) => {
                return <FormSelect required {...field} label="Select Package" options={biller?.packages.map((x) => ({ id: x.packageId, name: x.name }))} />;
              }}
            />
          </Stack>

          <Stack spacing={2} direction="row">
            <FormInput startAdornment={biller?.currencySymbol} label={"Surchage"} value={transactionFee} />
            <FormInput value={model.amount} isNumber required disabled={amount.disable} startAdornment={biller?.currencySymbol} label="Amount" {...register("amount")} helperText={errors.amount?.message} />
          </Stack>
        </Stack>
      </div>
    </div>
  );
};
